import * as React from 'react';
import styled from 'styled-components';
import {
  IDsiReportState,
  IDsiResult,
} from '../../../data/providers/reports/dsiReportProvider';
import { Entity } from '../../../data/types';
import { Column } from '../../layout/Column';
import { Row } from '../../layout/Row';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import { CardHeader } from '../../shared/card/CardHeader';
import { ListHeader } from '../../shared/List/ListHeader';
import { EPdfMode } from '../../shared/pdf/Pdf';
import { DsiResult } from './DsiResult';

interface IProps {
  reportState: IDsiReportState;
  pdfMode: EPdfMode;
  entity: Entity;
}

export const DsiResultList = (props: IProps): React.ReactElement => {
  const listShape = [0.5, 1, 1, 1, 1, 1];
  return (
    <Row>
      <Container>
        <Card
          style={{ marginTop: 'var(--grid-gap)' }}
          inverse={props.pdfMode === EPdfMode.PRINT}
        >
          <Column>
            <CardHeader surface={24} withListHeader>
              <Column>
                <ListHeader
                  leftAlignLastCell
                  shape={listShape}
                  labels={[
                    'Date',
                    'CMJ Peak Force',
                    'Iso Peak Force',
                    'DSI',
                    '% Difference',
                    'Total Difference',
                  ]}
                />
              </Column>
            </CardHeader>
            <CardBody>
              {props.reportState.resultList.map(
                (result: IDsiResult, index: number): React.ReactElement => {
                  return (
                    <DsiResult
                      result={result}
                      key={index}
                      pdfMode={props.pdfMode}
                      entity={props.entity}
                      shape={listShape}
                    />
                  );
                }
              )}
            </CardBody>
          </Column>
        </Card>
      </Container>
    </Row>
  );
};

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: var(--grid-gap);
`;
